import { useEffect } from 'react';

const setMeta = (name, content) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

export const useSeo = (title, description, keywords) => {
  useEffect(() => {
    if (!title) return;
    const prevTitle = document.title;
    document.title = title;
    if (description) setMeta('description', description);
    if (keywords?.length) setMeta('keywords', keywords.join(', '));
    return () => { document.title = prevTitle; };
  }, [title, description, keywords]);
};
